import React, {useEffect,useRef, useState} from 'react'
import { Wrapper,ProgressCircle,ProgressBar,ProgressContainer ,ProgressText} from './scrollIndicatorLandingStyles'
import { gsap,Power2,Power4,TimelineMax } from "gsap";

export default function ScrollIndicatorLanding({scrollRefreshWithoutDelay, setMainScrolling}) {

    const [positionTop, setPositioTop] = useState(800)

    const [indicatorComplete,setIndicatorComplete] = useState(false)
    
    let scrollIndicatorLan = useRef(null)
    let progressBarLan = useRef(null)

    let isScrolling

    let eightyPercentOfScreen = (window.innerHeight/100) * 80

    let fromRight = document.getElementById("root").getBoundingClientRect().right
    let rootWidth = document.getElementById("root").offsetWidth

    fromRight = fromRight - rootWidth

    let t1 = new TimelineMax({delay:5})
    let tlLine = new TimelineMax({repeat:20})

    const scrollListener = () => {
        if(!indicatorComplete){
            t1.restart(true)
            tlLine.restart()
            // setPositioTop(window.scrollY)

            // Clear our timeout throughout the scroll
            window.clearTimeout( isScrolling );
            

            // Set a timeout to run after scrolling ends
             isScrolling = setTimeout(function() {
                setPositioTop(window.scrollY + eightyPercentOfScreen)
            }, 66);

        }
    }

    useEffect(()=>{
        // if(indicatorComplete){
            setProgressAnimtion()
            // setAnimtionNoTimer()
        // }
    }, [])


    useEffect(()=>{
        window.addEventListener('scroll', scrollListener, true)
        return () => window.removeEventListener('scroll', scrollListener)   
    })

    const setProgressAnimtion = () => {
        t1.to(scrollIndicatorLan,{
            right:-75,
            opacity:1,
            ease:Power2.easeInOut,
        })
        t1.to(scrollIndicatorLan,{
            opacity:0,
            ease:Power4.easeInOut,
            delay:8
        }).then(()=>{
            setIndicatorComplete(true)
        })
        t1.pause()
        setAnimationLine()
    }

    const setAnimationLine = () => {
        tlLine.to(progressBarLan,{
            opacity:"1",
            width:"20%",
            ease:Power4.easeInOut,
        })
        tlLine.to(progressBarLan,{
            width:"100%",
            backgroundColor:"white",
            duration:0.01,
        })
        tlLine.to(progressBarLan,{
            display:"none",
            ease:Power4.easeInOut,
            delay:0.5
        })
        tlLine.to(progressBarLan,{
            width:"2px",
            backgroundColor:"gray",
            ease:Power4.easeInOut,
        })
        tlLine.pause()
    }


    // useEffect(()=>{
    //     console.warn("working in")
    //     t1.restart(false)
    //     tlLine.restart()
    // },[scrollRefreshWithoutDelay])

    return (
        <Wrapper id="indicator-landing" ref={ref => {scrollIndicatorLan = ref}} positionTop={positionTop} >
            <ProgressText >SWIPE</ProgressText>
            <ProgressCircle>
                <ProgressContainer>
                    <ProgressBar ref={ref => {progressBarLan = ref}} />
                </ProgressContainer>
            </ProgressCircle>
        </Wrapper>
    )
}
